import dayjs from "dayjs";
import { SystemMessage, SystemMessageStatus } from "./interfaces";

export const systemMessageStatuses: SystemMessageStatus[] = [
  SystemMessageStatus.ACTIVE,
  SystemMessageStatus.SCHEDULED,
  SystemMessageStatus.ENDED,
];

// The status follows from the time window, the backend does not store it
export const getSystemMessageStatus = (
  message: Pick<SystemMessage, "start_date" | "end_date">,
  now = dayjs()
): SystemMessageStatus => {
  if (now.isBefore(dayjs(message.start_date))) return SystemMessageStatus.SCHEDULED;
  if (now.isAfter(dayjs(message.end_date))) return SystemMessageStatus.ENDED;
  return SystemMessageStatus.ACTIVE;
};

// DOMParser builds an inert document, nothing in the html runs
const parseHtml = (html: string) =>
  new DOMParser().parseFromString(html ?? "", "text/html");

export const htmlToPlainText = (html: string) =>
  (parseHtml(html).body.textContent ?? "").replace(/\s+/g, " ").trim();

export const getPollIdsFromHtml = (html: string): number[] =>
  Array.from(parseHtml(html).querySelectorAll("[data-type='poll']"))
    .map((el) => Number(el.getAttribute("data-poll-id")))
    .filter((id) => Number.isInteger(id) && id > 0);
